<template>
    <div class="basic_wrap">
        <!-- 顶部标题栏 -->
        <div class="bank_card_header">
            <div class="back_left" @click="$router.go(-1)">
                <img src="../../../src/assets/images/return.png" :alt="$t('invest.DepositRecords')">
            </div>
            <div class="big_tit">{{ $t('invest.PersonalInformation') }}</div>
        </div>

        <!-- 主要内容区域 -->
        <div class="main_content">
            <!-- 加载状态 -->
            <div v-if="loading" class="loading_state">
                <div class="loading_text">{{ $t('item.Loading') }}</div>
            </div>
            
            <!-- 银行卡列表 -->
            <div v-else class="bank_cards_container">
                <!-- 空状态 -->
                <div v-if="!bankCards || bankCards.length === 0" class="empty_state">
                    <div class="empty_text">{{ $t('user.NoBankCard') }}</div>
                </div>
                
                <!-- 银行卡列表 -->
                <div v-else class="bank_cards_list">
                    <div 
                        v-for="(card, index) in bankCards" 
                        :key="card.id"
                        class="user_info_section"
                        :class="{ 'underline': index < bankCards.length - 1 }"
                    >
                        <div class="user_icon">
                            <div class="icon_circle">
                                <div class="checkmark">
                                    <img 
                                        :src="getCardLogo(card)" 
                                        :alt="card.bank"
                                        @error="handleImageError"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="user_text">{{ card.payment_type }}</div>
                    </div>
                </div>
                
                <!-- 添加提现方式按钮 -->
                <div class="add_bank_button" @click="goToAddBankCard">
                    <div class="add_button_icon">
                        <div class="plus_icon">+</div>
                    </div>
                    <div class="add_button_text">{{$t('user.addWithdrawMethod')}}</div>
                </div>
            </div>
        </div>

        <!-- 底部导航栏 -->
        <FooterTab :activeType="'user'" />
    </div>
</template>

<script>
import FooterTab from '../../components/FooterTab.vue'
import Fetch from '../../utils/fetch'

export default {
    name: "bankCard",
    components: { FooterTab },
    data() {
        return {
            show_icon_type: 'user',
            loading: false,
            bankCards: []
        };
    },
    created() {
        this.$parent.footer("user", false);
        this.show_icon_type = 'user';
        this.getBankCardInfo();
    },
    methods: {
        // 获取银行卡信息
        async getBankCardInfo() {
            try {
                this.loading = true;
                console.log('开始获取银行卡信息...');
                
                const result = await Fetch('/user/my_bank');
                console.log('银行卡信息API响应:', result);
                
                if (result && result.code === 1) {
                    console.log('获取银行卡信息成功:', result);
                    this.bankCards = result.data.bank || [];
                    
                    // 调试：检查每个银行卡的logo字段
                    this.bankCards.forEach((card, index) => {
                        console.log(`银行卡 ${index + 1}:`, {
                            id: card.id,
                            bank: card.bank,
                            account: card.account,
                            logo: card.logo
                        });
                    });
                    
                    // 如果没有银行卡，自动跳转到添加银行卡页面
                    // 注释掉自动跳转，改为显示空状态和添加按钮
                    // if (!this.bankCards || this.bankCards.length === 0) {
                    //     setTimeout(() => {
                    //         this.$router.push('/addBankCard');
                    //     }, 1000);
                    // }
                } else if (result && result.code === 0) {
                    console.log('获取银行卡信息业务提示:', result);
                    // 显示业务提示信息
                    let message = '';
                    if (typeof result.info === 'string') {
                        message = result.info;
                    } else if (typeof result.info === 'object') {
                        const currentLang = localStorage.getItem('lang') || 'zh_hk';
                        message = result.info[currentLang] || result.info.zh_cn || '获取银行卡信息失败';
                    }
                    console.warn(message);
                    
                    // 如果是没有银行卡的提示，不自动跳转，显示空状态和添加按钮
                    // setTimeout(() => {
                    //     this.$router.push('/addBankCard');
                    // }, 1000);
                } else {
                    console.error('获取银行卡信息失败:', result);
                }
            } catch (error) {
                console.error('获取银行卡信息请求出错:', error);
            } finally {
                this.loading = false;
            }
        },
        
        // 格式化银行卡号（隐藏中间部分）
        formatCardNumber(cardNumber) {
            if (!cardNumber) return '******';
            
            const str = String(cardNumber);
            
            // 如果账号中已经包含星号，说明后端已经脱敏处理，直接返回
            if (str.includes('*')) {
                return str;
            }
            
            if (str.length <= 6) {
                // 如果账号长度小于等于6位，全部显示星号
                return str.replace(/./g, '*');
            }
            
            // 保留前3位和后3位，中间用*代替
            const prefix = str.substring(0, 3);
            const suffix = str.substring(str.length - 3);
            const middle = '*'.repeat(Math.max(0, str.length - 6)); // 确保不会是负数
            
            return prefix + middle + suffix;
        },
        
        // 获取银行卡logo
        getCardLogo(card) {
            // 优先使用后端返回的logo字段
            if (card.logo && card.logo.trim() !== '') {
                console.log('使用银行卡logo:', card.logo);
                return card.logo;
            }
            
            // 如果没有logo字段，使用默认图标
            console.log('使用默认银行卡图标');
            return this.getDefaultCardIcon(card.bank);
        },
        
        // 获取默认银行卡图标
        getDefaultCardIcon(bankType) {
            // 使用本地静态图片，避免网络请求失败
            const iconMap = {
                'USDT(TRC-20)': require('../../../src/assets/images/card1.png'),
                'USDT(ERC-20)': require('../../../src/assets/images/card2.png'),
                'BTC': require('../../../src/assets/images/card1.png'),
                'ETH': require('../../../src/assets/images/card2.png'),
                // 可以根据实际返回的银行类型添加更多映射
                'default': require('../../../src/assets/images/card1.png')
            };
            
            return iconMap[bankType] || iconMap['default'];
        },
        
        // 处理图片加载错误
        handleImageError(event) {
            // 防止无限循环：如果已经是默认图标还失败，就不再重试
            if (event.target.dataset.isDefault === 'true') {
                console.warn('默认图标也加载失败，停止重试');
                return;
            }
            
            console.warn('银行卡logo加载失败，使用默认图标');
            event.target.src = this.getDefaultCardIcon('default');
            event.target.dataset.isDefault = 'true'; // 标记为默认图标
        },
        
        // 跳转到添加银行卡页面
        goToAddBankCard() {
            this.$router.push('/addBankCard');
        }
    }
};
</script>

<style lang="less" scoped>
.basic_wrap {
    // min-height: 100vh;
    background: #ffffff;
    display: flex;
    flex-direction: column;
}

.bank_card_header {
    position: relative;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    color: #000000;
    border-bottom: 1px solid #f0f0f0;

    .back_left {
        position: absolute;
        left: 15px;
        top: 0;
        bottom: 0;
        cursor: pointer;
        background: none;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 16px;
            height: 16px;
        }
    }

    .big_tit {
        font-size: 16px;
        font-weight: 500;
        color: #000000;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.main_content {
    flex: 1;
    background: #ffffff;
    padding: 20px 16px;
}

.bank_cards_container {
    width: 100%;
}

.loading_state, .empty_state {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    color: #999999;
    font-size: 14px;
}

.bank_cards_list {
    width: 100%;
    margin-bottom: 20px;
}

.add_bank_button {
    display: flex;
    align-items: center;
    padding: 20px;
    margin-top: 20px;
    background: #ffffff;
    border: 2px dashed #52c41a;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s;
    
    &:hover {
        background-color: #f6ffed;
        border-color: #389e0d;
    }
    
    &:active {
        transform: scale(0.98);
    }
    
    .add_button_icon {
        margin-right: 16px;
        
        .plus_icon {
            width: 50px;
            height: 50px;
            background: #52c41a;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            font-size: 30px;
            font-weight: bold;
            line-height: 1;
        }
    }
    
    .add_button_text {
        flex: 1;
        font-size: 16px;
        color: #52c41a;
        font-weight: 500;
    }
}

.user_info_section {
    display: flex;
    align-items: center;
    margin-bottom: 10px;


    .user_icon {
        margin-right: 16px;

        .icon_circle {
            width: 60px; // 调整为与图片相同的尺寸
            height: 60px; // 调整为与图片相同的尺寸
            // background: #1890ff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            // overflow: hidden; // 移除这行，因为现在不需要裁剪了

            .checkmark {
                color: #fadb14;
                font-size: 24px;
                font-weight: bold;

                img {
                    width: 60px;
                    height: 60px;
                    object-fit: cover; // 保持图片比例
                    border-radius: 8px; // 圆角
                    border: 1px solid #f0f0f0; // 边框
                }
            }
        }
    }

    .user_text {
        font-size: 14px;
        color: #0000004D;
        font-weight: 500;
    }
}

.underline {
    border-bottom: 1px solid #f0f0f0;
}

.card_info_section {
    display: flex;
    align-items: center;
    padding: 20px 0;

    .card_image {
        margin-right: 16px;

        .credit_card {
            width: 120px;
            height: 75px;
            background: linear-gradient(135deg, #52c41a, #389e0d);
            border-radius: 8px;
            padding: 12px;
            position: relative;
            overflow: hidden;

            &::before {
                content: '';
                position: absolute;
                top: -10px;
                right: -10px;
                width: 40px;
                height: 40px;
                background: rgba(255, 255, 255, 0.2);
                border-radius: 50%;
            }

            &::after {
                content: '';
                position: absolute;
                bottom: -5px;
                left: -5px;
                width: 30px;
                height: 30px;
                background: rgba(255, 255, 255, 0.15);
                border-radius: 50%;
            }

            .card_content {
                color: #ffffff;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .card_title {
                    font-size: 12px;
                    font-weight: 500;
                    margin-bottom: 8px;
                }

                .card_number {
                    font-size: 10px;
                    font-weight: 500;
                    letter-spacing: 1px;
                    margin-bottom: 4px;
                }

                .card_details {
                    font-size: 8px;
                    opacity: 0.9;
                }
            }
        }
    }

    .card_text {
        font-size: 18px;
        color: #333333;
        font-weight: 500;
    }
}

/* 底部导航栏样式 */
.footer {
    position: fixed;
    margin: 0 auto;
    left: 0;
    right: 0;
    flex: 0 0 48px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: #fff;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
    width: 100%;
    max-width: 750px;
    bottom: 0;
    height: 60px;
    z-index: 4;
}

.footer .footer_item {
    display: flex;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
    color: #55585a;
    width: 60px;
}

.footer .footer_item .footer_icon {
    display: inline-block;
    width: 26px;
    height: 26px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    margin-bottom: 6px;
}

.footer .footer_item .footer_icon.footer_icon_home {
    background-image: url(../../../src/assets/images/tab/shou.png);
}

.footer .footer_item .footer_icon.footer_icon_task {
    background-image: url(../../../src/assets/images/tab/item.png);
}

.footer .footer_item .footer_icon.footer_icon_cart {
    background-image: url(../../../src/assets/images/tab/kefu.png);
}

.footer .footer_item .footer_icon.footer_icon_user {
    background-image: url(../../../src/assets/images/tab/my.png);
}

.footer .footer_item .footer_info {
    font-size: 12px;
}

.footer .footer_item.footer_item_active {
    color: #3775f4;
}
</style>